export default "/_next/static/chunks/fonts/Montserrat Thin-b22f9dec14cbf74ca2b20d98747ce609.otf";